import { animate, utils, createDraggable, spring, onScroll, createTimeline } from 'animejs';

const animeCardflip = () => {
    const container = document.querySelector('.animate--flip-container');

    if (container) {
        // Create a timeline that handles both sides at the same time
        let flipAnimation = createTimeline({
            autoplay: false,
            easing: 'easeInOutQuad',
            duration: 300,
            onUpdate: function(anim) {

                if (anim._currentTime > 300 && !anim.reversed) {
                    document.querySelector('.animate--frontflip').classList.add('animate--halfway');
                    document.querySelector('.animate--backflip').classList.add('animate--halfway');
                }

                if (anim.reversed) {
                    console.log(anim._currentTime)
                }
                
                if (anim._currentTime > 750 && anim.reversed) {
                    // Optional: Remove it if the animation resets or plays in reverse
                    document.querySelector('.animate--frontflip').classList.remove('animate--halfway');
                    document.querySelector('.animate--backflip').classList.remove('animate--halfway');
                }
            }
        })

        // Add the front face animation (0deg to -180deg)
        flipAnimation.add('.animate--frontflip', {
            rotateY: [-0, -180]
        })

        // Add the back face animation (180deg to 0deg) at the exact same time (0ms offset)
        flipAnimation.add('.animate--backflip', {
            rotateY: [180, 0]
        }, 0);

        // Trigger the animation on hover
        container.addEventListener('mouseenter', () => {
            console.log('enter')
            flipAnimation.play();
        });

        // Reverse the animation when the mouse leaves
        container.addEventListener('mouseleave', () => {
            console.log('leave')
            flipAnimation.reverse();
        })
    }
}

export { animeCardflip } 